module.exports = __webpack_public_path__ + "f8ac46ee6f7208cfc5c539b1c25726c0.svg";